import { get, post } from 'api';
import config from 'config';

const customerUrl = config.get('api.customer');
const authenticationUrl = config.get('api.authentication');

interface ICheckUserEmailRequest {
  email: string;
}
interface IUpdateUserEmailRequest {
  userId: string;
  userName: string;
  email: string;
  redirectUrl: string;
}

export const DashboardAPI = {
  getAllReports: async (dealerId: number): Promise<any | null> => {
    const { data } = await get(`${customerUrl}/customers/stats?dealerId=${dealerId}`);
    return data;
  },

  checkUserEmail: async (body: ICheckUserEmailRequest): Promise<any | null> => {
    const { data } = await post(`${authenticationUrl}/checkUserEmail`, body);
    return data;
  },

  updateUserEmail: async (body: IUpdateUserEmailRequest): Promise<any | null> => {
    const { data } = await post(`${authenticationUrl}/updateUserEmail`, body);
    return data;
  },

  getUserEmailStatus: async (userId: string): Promise<any | null> => {
    const { data } = await get(`${authenticationUrl}/getUserEmail/${userId}`);
    return data;
  },
};

export default DashboardAPI;
